import { render, staticRenderFns } from "./LandingPageFooter.vue?vue&type=template&id=1bc4d146&scoped=true"
import script from "./LandingPageFooter.vue?vue&type=script&lang=js"
export * from "./LandingPageFooter.vue?vue&type=script&lang=js"
import style0 from "./LandingPageFooter.vue?vue&type=style&index=0&id=1bc4d146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc4d146",
  null
  
)

export default component.exports